import { render, staticRenderFns } from "./DrugUseRemindEdit.vue?vue&type=template&id=7971ee4e&scoped=true&"
import script from "./DrugUseRemindEdit.vue?vue&type=script&lang=js&"
export * from "./DrugUseRemindEdit.vue?vue&type=script&lang=js&"
import style0 from "./DrugUseRemindEdit.vue?vue&type=style&index=0&id=7971ee4e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7971ee4e",
  null
  
)

export default component.exports